import type { Messages } from './index';

/**
 * Portuguese (pt) translation dictionary. Typed as `Messages` so it must mirror
 * the English shape exactly — a missing or mistyped key fails the build.
 */
export const pt: Messages = {
  nav: {
    virtual: 'Foto Virtual',
    museum: 'O Museu',
    visit: 'Visitar',
    store: 'Loja',
    menu: 'Menu',
  },
  hero: {
    sub: 'Madeira · Portugal',
    titleThin: 'CR7',
    titleShine: 'Museu',
    tagline: 'O legado de Cristiano Ronaldo, contado na sua terra natal.',
    plan: 'Planear a visita',
    store: 'Loja online',
    scroll: 'Descer',
  },
  stats: {
    ballon: 'Bolas de Ouro',
    ucl: 'Champions League',
    boots: 'Botas de Ouro',
    uefa: 'Melhor Jogador da UEFA',
  },
  virtual: {
    badge: 'Foto Virtual',
    kicker: 'Foto Virtual',
    title: 'CR7 em Realidade Aumentada',
    text: 'Interaja com o Cristiano Ronaldo e tire fotografias como se estivesse mesmo ao seu lado. Uma nova forma de viver a experiência CR7.',
    cta: 'Saber mais',
  },
  museum: {
    kicker: 'O Museu',
    title: 'Uma vida em troféus',
    intro:
      'Todos os troféus juvenis e profissionais conquistados por Cristiano Ronaldo, dos primeiros passos na Madeira aos maiores palcos do futebol mundial.',
    cards: {
      boots: {
        title: 'Botas de Ouro',
        text: 'Quatro vezes o melhor marcador da Europa. As botas de ouro estão aqui, para a posteridade.',
      },
      ballon: {
        title: 'Bola de Ouro',
        text: 'Cinco vezes o Melhor Jogador do Mundo, e o melhor jogador português de todos os tempos.',
      },
      clubs: {
        title: 'Troféus de Clubes',
        text: 'Todos os troféus conquistados nos clubes por onde passou, incluindo cinco UEFA Champions League.',
      },
      fans: {
        title: 'Correspondência dos Fãs',
        text: 'Fãs de todo o mundo escrevem, desenham, pintam e enviam homenagens ao Cristiano Ronaldo.',
      },
      ar: {
        title: 'Realidade Aumentada',
        text: 'Interaja com o Ronaldo e leve para casa uma fotografia ao lado do craque.',
      },
      memorabilia: {
        title: 'Memorabilia',
        text: 'Camisolas, chuteiras, fotografias e objetos únicos que marcaram a carreira do craque madeirense.',
      },
    },
  },
  experience: {
    kicker: 'CR7 Museu Madeira',
    title: 'Onde a jornada começou',
    text: 'Local icónico · Espaço imersivo · Uma vida de troféus',
  },
  visit: {
    kicker: 'Visitar',
    title: 'Planeie a sua visita',
    addressLabel: 'Morada',
    hoursLabel: 'Horário',
    hours: 'Todos os dias · 10h00 – 17h00',
    note: 'Em caso de encerramento pontual, a informação será divulgada nas redes sociais com a devida antecedência.',
    contactLabel: 'Contactos',
    map: 'Ver no mapa',
  },
  footer: {
    tagline: 'O museu oficial dedicado a Cristiano Ronaldo, no Funchal, Madeira.',
    explore: 'Explorar',
    contact: 'Contactos',
    location: 'Funchal, Madeira',
    rights: 'Todos os direitos reservados.',
  },
};
